import { PagingParameters } from "@/api/dtos";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

type PaginationContextType = {
  pagination: PagingParameters;
  setPagination: Dispatch<SetStateAction<PagingParameters>>;
  lastPosition?: number;
  setLastPosition: Dispatch<SetStateAction<number | undefined>>;
};

export const PaginationContext = createContext<
  PaginationContextType | undefined
>(undefined);

export const usePagination = () => {
  const context = useContext(PaginationContext);
  if (!context) {
    throw new Error("usePagination must be used within a PaginationProvider");
  }
  return context;
};
